import { Camera } from "lucide-react";
import { Dropzone } from "@/components/kibo-ui/dropzone";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { cn, getInitials } from "@/lib/utils";

/**
 * Rundes Avatar-Upload-Feld mit echtem Drag&Drop (kibo-ui Dropzone), überall dort
 * eingesetzt, wo ein Profilbild lokal als Base64-Vorschau gehalten wird, bis das
 * umgebende Formular gespeichert wird (Bearbeiter-Dialog/-Sheet, eigenes Profil).
 */
export function AvatarUpload({
  value,
  onChange,
  name,
  disabled,
  className
}: {
  value: string;
  onChange: (value: string) => void;
  name: string;
  disabled?: boolean;
  className?: string;
}) {
  const handleDrop = (files: File[]) => {
    const file = files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => onChange(String(reader.result || ""));
    reader.readAsDataURL(file);
  };

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <Dropzone
        accept={{ "image/*": [] }}
        maxFiles={1}
        disabled={disabled}
        onDrop={handleDrop}
        className="group relative size-16 shrink-0 rounded-full border-transparent bg-transparent p-0 hover:bg-transparent"
      >
        <Avatar size="lg" className="size-16">
          {value ? <AvatarImage src={value} alt="" /> : null}
          <AvatarFallback>{getInitials(name)}</AvatarFallback>
        </Avatar>
        <div className="absolute inset-0 flex items-center justify-center rounded-full bg-black/0 text-transparent transition group-hover:bg-black/40 group-hover:text-white">
          <Camera className="size-5" aria-hidden="true" />
        </div>
      </Dropzone>
      <div className="flex flex-col items-start gap-1">
        <p className="text-xs text-muted-foreground">Klicken oder Bild hierher ziehen</p>
        {value ? (
          <Button type="button" variant="ghost" size="sm" className="h-auto p-0 text-xs" onClick={() => onChange("")}>
            Bild entfernen
          </Button>
        ) : null}
      </div>
    </div>
  );
}
